export const Purpose_of_Enquiry_Options = [
  {
    name: 'Purpose of Enquiry' ,
    value: 'Purpose of Enquiry',
  },
  {
    name: 'General Enquiry',
    value: 'General Enquiry',
  },
  {
    name: 'Warranty Enquiry',
    value: 'Warranty Enquiry',
  },
];
export const Methven_Brands = [
  {
    name: 'Select Brand' ,
    value: 'Select Brand',
  },
  {
    name: 'Methven' ,
    value: 'Methven',
  },
  {
    name: 'Flexispray',
    value: 'Flexispray',
  },
];
export const Preferred_Contact_Method_Options = [
  { name: 'Preferred Contact Method', value: 'Preferred Contact Method' },
  {
    name: 'Email',
    value: 'Email',
  },
  {
    name: 'Mail',
    value: 'Mail',
  },
  {
    name: 'Phone',
    value: 'Phone',
  },
  {
    name: 'Mobile',
    value: 'Mobile',
  },
];
export const Occupation_Options = [
  { name: 'Occupation', value: 'Occupation' },
  {
    name: 'Homeowner - Building Renovating',
    value: 'Homeowner - Building Renovating',
  },
  {
    name: 'Builder',
    value: 'Builder',
  },
  {
    name: 'Developer',
    value: 'Developer',
  },
  {
    name: 'Plumber',
    value: 'Plumber',
  },
  {
    name: 'Hydraulic Consultant',
    value: 'Hydraulic Consultant',
  },
  {
    name: 'Architect',
    value: 'Architect',
  },
  {
    name: 'Designer',
    value: 'Designer',
  },
  {
    name: 'Plumbing Merchant',
    value: 'Plumbing Merchant',
  },
];
export const Source_Site = 'methven';